import React, { useState } from "react";
import axios from "axios";

import ReceptionForm from "./reception-form";
import LoadReviewForm from "./load-review-form";
import CubiscanForm from "./cubiscan-form";
import LocationsForm from "./locations-form";

function FormsView({ master }) {
  const [activeForm, setActiveForm] = useState(null);
  const [selectedSubproduct, setSelectedSubproduct] = useState(false);
  const [formData, setFormData] = useState({});

  console.log("🧾 Master completo recibido en FormsView:", master);
  console.log("🔍 Estructura de resp:", master?.resp);
  console.log("🔍 master.resp.id:", master?.resp?.id);
  console.log("🔍 master.resp.master_id:", master?.resp?.master_id);
  console.log(
    "🔍 Houses con rec_id:",
    master?.data?.map((h) => ({
      id: h.id,
      rec_id: h.rec_id,
      hbs: h.hbs,
    }))
  );

  // Función segura para verificar valores
  const safeValue = (value, defaultValue = null) => {
    return value !== null && value !== undefined ? value : defaultValue;
  };

  const isWithSubproducts =
    Array.isArray(master?.data) && master.data.length > 0;

  const handleFormClick = (form) => {
    setActiveForm(form);
    setSelectedSubproduct(null);
  };

  const showForm = async (sub) => {
    try {
      // ✅ CORREGIDO: Usar el ID correcto del master
      const masterId = master.resp?.id || master.resp?.master_id;

      const response = await axios.get(
        `${process.env.REACT_APP_URL_EXPO}/api/v1/exp_entries/reception_form?master_id=${masterId}&house_id=${sub.id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("================ FORM DATA RESPONSE ====================");
      console.log("Master ID usado:", masterId);
      console.log("House ID usado:", sub.id);
      console.log("Respuesta completa:", response.data);
      console.log("preve_save recibido:", response.data?.data?.preve_save);
      console.log("========================================================");

      if (response.data && response.data.code === 1) {
        setFormData(response.data.data);
        setSelectedSubproduct(sub);
        setActiveForm("reception");
      }
    } catch (error) {
      console.error("Error al cargar formulario:", error);
      console.error("Error response:", error.response?.data);
    }
  };

  const renderForm = () => {
    if (activeForm === "reception")
      return (
        <ReceptionForm master={formData} subproduct={selectedSubproduct} />
      );
    if (activeForm === "review")
      return <LoadReviewForm master={master} subproduct={selectedSubproduct} />;
    if (activeForm === "cubiscan")
      return <CubiscanForm master={master} subproduct={selectedSubproduct} />;
    if (activeForm === "locations")
      return <LocationsForm master={master} subproduct={selectedSubproduct} />;
    return null;
  };

  return (
    <div className="container-fluid">
      {/* Botones para cambiar de formulario */}
      {!isWithSubproducts && selectedSubproduct && (
        <div className="d-flex gap-3 mb-4">
          <button
            onClick={() => handleFormClick("reception")}
            className={`btnn ${activeForm === "reception" ? "active" : ""}`}
          >
            Recepción de documentos
          </button>
          <button
            onClick={() => handleFormClick("review")}
            className={`btnn ${activeForm === "review" ? "active" : ""}`}
          >
            Revisión de la carga
          </button>
          <button
            onClick={() => handleFormClick("cubiscan")}
            className={`btnn ${activeForm === "cubiscan" ? "active" : ""}`}
          >
            Cubiscan
          </button>
          <button
            onClick={() => handleFormClick("locations")}
            className={`btnn ${activeForm === "locations" ? "active" : ""}`}
          >
            Locaciones
          </button>
        </div>
      )}

      {/* Mostrar formulario principal siempre */}
      {renderForm()}

      {/* Mostrar tabla solo si hay subproductos y no hay ninguno seleccionado */}
      {isWithSubproducts && !selectedSubproduct && (
        <>
          <table
            className="table mt-5"
            style={{ width: "70%", margin: "0 auto" }}
          >
            <thead className="text-center">
              <tr>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  HBS
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Fecha
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Piezas
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Peso
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody className="text-center">
              {master.data?.map((sub, _index) => (
                <tr key={_index}>
                  <td>{safeValue(sub.hbs, "N/A")}</td>
                  <td>{safeValue(sub.date, "N/A")}</td>
                  <td>{safeValue(sub.pieces, "N/A")}</td>
                  <td>{safeValue(sub.weight, "N/A")}</td>
                  <td>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => showForm(sub)}
                    >
                      ➜
                    </button>
                  </td>
                </tr>
              )) || (
                <tr>
                  <td colSpan="5" className="text-center">
                    No hay subproductos disponibles
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      )}

      {/* Mensaje para cuando no hay datos */}
      {!master && (
        <div className="alert alert-warning text-center">
          No se encontraron datos del master
        </div>
      )}
    </div>
  );
}

export default FormsView;
